import { Star, Sun, Moon } from "lucide-react";

export const FOCUS_META = {
  keystone: { label: "Keystone", icon: Star, cls: "bg-amber-400 text-stone-900", hint: "Your one main focus — bigger rewards, full reminders" },
  active: { label: "Active", icon: Sun, cls: "bg-emerald-100 text-emerald-800", hint: "Working on it steadily" },
  background: { label: "Background", icon: Moon, cls: "bg-stone-100 text-stone-600", hint: "Ticking over lightly — one gentle nudge, no escalation" },
};

export function FocusBadge({ focus = "active", setBy, habitId }) {
  const m = FOCUS_META[focus] || FOCUS_META.active;
  const Icon = m.icon;
  return (
    <span className="inline-flex items-center gap-1.5">
      <span data-testid={`focus-badge-${habitId}`} className={`inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-widest px-2 py-1 rounded-full ${m.cls}`} title={m.hint}>
        <Icon className={`w-3 h-3 ${focus === "keystone" ? "fill-stone-900" : ""}`} /> {m.label}
      </span>
      {setBy === "clinician" && <span className="text-[10px] text-stone-500 italic" data-testid={`focus-set-by-${habitId}`}>set with your coach</span>}
    </span>
  );
}

export function FocusPicker({ value = "active", onChange, habitId, compact = false }) {
  return (
    <div className="flex flex-wrap gap-1" data-testid={`focus-picker-${habitId}`}>
      {Object.entries(FOCUS_META).map(([k, m]) => {
        const Icon = m.icon;
        const on = value === k;
        return (
          <button key={k} type="button" data-testid={`focus-${k}-${habitId}`} onClick={() => !on && onChange(k)} title={m.hint}
            className={`inline-flex items-center gap-1 rounded-full font-semibold transition ${compact ? "text-[10px] px-2 py-0.5" : "text-xs px-2.5 py-1"} ${on ? m.cls + " ring-2 ring-offset-1 ring-stone-300" : "bg-white border border-stone-200 text-stone-500 hover:bg-stone-50"}`}>
            <Icon className="w-3 h-3" /> {m.label}
          </button>
        );
      })}
    </div>
  );
}
